// config.js
export const API_BASE_URL = 'https://api.theresaacademy.com';
export const API_IMAGE_URL = 'https://api.theresaacademy.com/uploads';